module.exports = __webpack_public_path__ + "static/media/Ki.451fd5be.svg";